import { lazyRetry } from "../../../utils/lazyRetry";

import type { Route } from "../../../routes/RouteModel";

const Login = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "AuthLogin" */
      /* webpackPreload: true */
      "../pages/Login"
    ),
  "AuthLogin"
);
const ForgotPassword = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "AuthPassword" */
      /* webpackPrefetch: true */
      "../pages/ForgotPassword"
    ),
  "AuthPassword"
);
const ResetPassword = lazyRetry(
  () =>
    import(
      /* webpackChunkName: "AuthPassword" */
      /* webpackPrefetch: true */
      "../pages/ResetPassword"
    ),
  "AuthPassword"
);

export const authRoutes: Route[] = [
  {
    i18nName: "Login",
    path: "/login",
    component: Login,
    newTheme: true,
  },
  {
    i18nName: "Forgot password",
    path: "/forgot-password",
    component: ForgotPassword,
    newTheme: true,
  },
  {
    i18nName: "Reset password",
    path: "/reset-password/:token",
    component: ResetPassword,
    newTheme: true,
  },
];
